import { useAction, useAtom } from "@reatom/npm-react";

import { filterAtom, updateFilters } from "../store/atoms/filterQuery";

export const useProductFilters = () => {
  const [filter] = useAtom(filterAtom);
  const applyFilters = useAction(updateFilters);

  return {
    filter,
    updateFilters: applyFilters,
  };
};
